/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { CustomerSubscriptionData_CustomerFragmentDoc } from '../../../customers/__generated__/CustomersGridItem.graphql';
import { ScheduleDetailMoreActions_ScheduleFragmentDoc } from './ScheduleDetailMoreActions.graphql';
import { SyncScheduleDisplaysModal_ScheduleFragmentDoc } from '../../__generated__/SyncScheduleDisplaysModal.graphql';
import { DeleteSchedulesModal_ScheduleFragmentDoc } from '../../__generated__/DeleteSchedulesModal.graphql';
import { EditScheduleModal_ScheduleFragmentDoc } from './EditScheduleModal.graphql';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ScheduleDetail_CustomerFragment = { __typename: 'Customer', id: string, name: string, inputSources: Array<string>, displayCount: number, waveSubscriptionUsage?: number | null, playlists: Array<{ __typename: 'Playlist', id: string, title: string, playlistType: Types.PlaylistType }>, schedules: Array<{ __typename: 'Schedule', id: string }>, waveSubscription?: { __typename: 'WaveSubscription', id: string, usage: { __typename: 'SubscriptionUsage', current: number, max?: number | null } } | null, waveSubscriptions?: Array<{ __typename: 'WaveSubscription', id: string, validUntil: any, status: Types.WaveSubscriptionStatus, usage: { __typename: 'SubscriptionUsage', current: number, max?: number | null } }> | null };

export type ScheduleDetail_ScheduleFragment = { __typename: 'Schedule', id: string, title: string, description: string, isLegacy: boolean, isScheduleUsedByAnyConfiguration: boolean, timeBlocks: Array<{ __typename: 'ScheduleTimeBlock', day: Types.Day, start: string, end: string, type: Types.TimeBlockType, priority: number, category: Types.TimeBlockCategory, data: { __typename: 'ScheduleTimeBlockData', applicationId?: string | null, id?: string | null, mediaType?: string | null, source?: string | null, url?: string | null, value?: number | null } }>, allDisplays: Array<{ __typename: 'Display', id: string }>, syncedDisplays: Array<{ __typename: 'Display', id: string }>, outOfSyncDisplays: Array<{ __typename: 'Display', id: string }>, syncingDisplays: Array<{ __typename: 'Display', id: string }>, removingDisplays: Array<{ __typename: 'Display', id: string }> };

export type ScheduleDuplicateMutationVariables = Types.Exact<{
  input: Types.ScheduleDuplicateInput;
}>;


export type ScheduleDuplicateMutation = { __typename: 'Mutation', scheduleDuplicate: { __typename: 'ScheduleDuplicatePayload', schedule: { __typename: 'Schedule', id: string } } };

export type ScheduleUpdateMutationVariables = Types.Exact<{
  input: Types.ScheduleUpdateInput;
}>;


export type ScheduleUpdateMutation = { __typename: 'Mutation', scheduleUpdate: { __typename: 'ScheduleUpdatePayload', schedule: { __typename: 'Schedule', id: string, title: string, description: string, isLegacy: boolean, isScheduleUsedByAnyConfiguration: boolean, timeBlocks: Array<{ __typename: 'ScheduleTimeBlock', day: Types.Day, start: string, end: string, type: Types.TimeBlockType, priority: number, category: Types.TimeBlockCategory, data: { __typename: 'ScheduleTimeBlockData', applicationId?: string | null, id?: string | null, mediaType?: string | null, source?: string | null, url?: string | null, value?: number | null } }>, allDisplays: Array<{ __typename: 'Display', id: string }>, syncedDisplays: Array<{ __typename: 'Display', id: string }>, outOfSyncDisplays: Array<{ __typename: 'Display', id: string }>, syncingDisplays: Array<{ __typename: 'Display', id: string }>, removingDisplays: Array<{ __typename: 'Display', id: string }> } } };

export const ScheduleDetail_CustomerFragmentDoc = gql`
    fragment ScheduleDetail_customer on Customer {
  id
  name
  inputSources
  playlists {
    id
    title
    playlistType
  }
  schedules {
    id
  }
  ...CustomerSubscriptionData_customer
}
    ${CustomerSubscriptionData_CustomerFragmentDoc}`;
export const ScheduleDetail_ScheduleFragmentDoc = gql`
    fragment ScheduleDetail_schedule on Schedule {
  id
  title
  description
  isLegacy
  isScheduleUsedByAnyConfiguration
  timeBlocks {
    day
    start
    end
    type
    priority
    category
    data {
      applicationId
      id
      mediaType
      source
      url
      value
    }
  }
  allDisplays: displays {
    id
  }
  syncedDisplays: displays(filter: {state: SYNCED}) {
    id
  }
  outOfSyncDisplays: displays(filter: {state: OUT_OF_SYNC}) {
    id
  }
  syncingDisplays: displays(filter: {state: SYNCING}) {
    id
  }
  removingDisplays: displays(filter: {state: REMOVING}) {
    id
  }
  ...ScheduleDetailMoreActions_schedule
  ...SyncScheduleDisplaysModal_schedule
  ...DeleteSchedulesModal_schedule
  ...EditScheduleModal_schedule
}
    ${ScheduleDetailMoreActions_ScheduleFragmentDoc}
${SyncScheduleDisplaysModal_ScheduleFragmentDoc}
${DeleteSchedulesModal_ScheduleFragmentDoc}
${EditScheduleModal_ScheduleFragmentDoc}`;
export const ScheduleDuplicateDocument = gql`
    mutation ScheduleDuplicate($input: ScheduleDuplicateInput!) {
  scheduleDuplicate(input: $input) {
    schedule {
      id
    }
  }
}
    `;
export type ScheduleDuplicateMutationFn = ApolloReactCommon.MutationFunction<ScheduleDuplicateMutation, ScheduleDuplicateMutationVariables>;

/**
 * __useScheduleDuplicateMutation__
 *
 * To run a mutation, you first call `useScheduleDuplicateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleDuplicateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleDuplicateMutation, { data, loading, error }] = useScheduleDuplicateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduleDuplicateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ScheduleDuplicateMutation, ScheduleDuplicateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ScheduleDuplicateMutation, ScheduleDuplicateMutationVariables>(ScheduleDuplicateDocument, options);
      }
export type ScheduleDuplicateMutationHookResult = ReturnType<typeof useScheduleDuplicateMutation>;
export type ScheduleDuplicateMutationResult = ApolloReactCommon.MutationResult<ScheduleDuplicateMutation>;
export type ScheduleDuplicateMutationOptions = ApolloReactCommon.BaseMutationOptions<ScheduleDuplicateMutation, ScheduleDuplicateMutationVariables>;
export const ScheduleUpdateDocument = gql`
    mutation ScheduleUpdate($input: ScheduleUpdateInput!) {
  scheduleUpdate(input: $input) {
    schedule {
      id
      ...ScheduleDetail_schedule
    }
  }
}
    ${ScheduleDetail_ScheduleFragmentDoc}`;
export type ScheduleUpdateMutationFn = ApolloReactCommon.MutationFunction<ScheduleUpdateMutation, ScheduleUpdateMutationVariables>;

/**
 * __useScheduleUpdateMutation__
 *
 * To run a mutation, you first call `useScheduleUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleUpdateMutation, { data, loading, error }] = useScheduleUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduleUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ScheduleUpdateMutation, ScheduleUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ScheduleUpdateMutation, ScheduleUpdateMutationVariables>(ScheduleUpdateDocument, options);
      }
export type ScheduleUpdateMutationHookResult = ReturnType<typeof useScheduleUpdateMutation>;
export type ScheduleUpdateMutationResult = ApolloReactCommon.MutationResult<ScheduleUpdateMutation>;
export type ScheduleUpdateMutationOptions = ApolloReactCommon.BaseMutationOptions<ScheduleUpdateMutation, ScheduleUpdateMutationVariables>;